import { RouteObject } from "react-router-dom";
import { PAYMENT } from "constants/urls";

export default [
  {
    index: true,
    path: PAYMENT,
    lazy: () => import("modules/payment/pages/Payment"),
  },
] as RouteObject[];
